/**
 * Applies a per-testlet-type override (ASSMNT-2005) on top of a component's default idle
 * timeouts, then applies the existing assessment timeout-extension multiplier on whichever
 * base value is in effect. Shared by ModularMultipleChoice and SentenceBuilder so the two
 * don't drift.
 */
export function resolveIdleTimeouts(idleTimeoutOverrides, defaultTimeouts, shouldExtendTimeout, timeoutExtensionMultiplier) {
  const baseIdleEncouragementTimeout = idleTimeoutOverrides?.idleEncouragementTimeout ?? defaultTimeouts.idleEncouragementTimeout;
  const baseSubmitTimeout = idleTimeoutOverrides?.idleSubmitTimeout ?? defaultTimeouts.idleSubmitTimeout;
  const shouldExtend = shouldExtendTimeout && timeoutExtensionMultiplier;

  return {
    idleEncouragementTimeout: shouldExtend
      ? Math.round(baseIdleEncouragementTimeout * timeoutExtensionMultiplier)
      : baseIdleEncouragementTimeout,
    idleSubmitTimeout: shouldExtend
      ? Math.round(baseSubmitTimeout * timeoutExtensionMultiplier)
      : baseSubmitTimeout,
  };
}
